import { combineReducers } from "redux";
import { reducer as formReducer } from "redux-form";

// Reducers
import PeopleReducer from "./PeopleReducer";
import AttendeePageReducer from "./AttendeePageReducer";

import EventsReducer from "./EventsReducer";
import EventPageReducer from "./EventPageReducer";

import UserReducer from "./UserReducer";

// These Are The Properties Inside Redux Store
export default combineReducers({
    user: UserReducer,
    form: formReducer,
    people: PeopleReducer,
    events: EventsReducer,
    attendeePage: AttendeePageReducer,
    eventPage: EventPageReducer
});
